<template>
    <DefaultLayout>
        <div v-if="loading">
            <v-icon name="ri-loader-2-fill" animation="spin" class="icon" />
        </div>
        <div class="container">
            <h1>¡Bienvenido a nuestra sección de Ejercicios!</h1>
            <p>Accede a las secciones de ejercicios correspondientes a los cursos adquiridos y practica con ejercicios diseñados específicamente para reforzar los conocimientos impartidos en cada curso. </p>
                <br>
            <div class="table-container">
                <table class="modern-table">
                    <thead>
                        <tr>
                            <th  v-if="windowWidth > tableSmall">{{ main.TH_1_ACTIVITY_COURSE_VIEW }}</th>
                            <th>{{ main.TH_2_ACTIVITY_COURSE_VIEW }}</th>
                            <th>{{ main.TH_3_ACTIVITY_COURSE_VIEW }}</th>
                            <th>{{ main.TH_4_ACTIVITY_COURSE_VIEW }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="elm in activities"  :key="elm?.id">
                            <td>{{ elm?.language }}</td>
                            <td>{{ elm?.number_of_execercises }}</td>
                            <td>{{ elm?.date }}</td>
                            <td>
                                <RouterLink :to="{ name: 'viewActivity', params:{id : elm?.id} }"><v-icon name="md-fileopen-round" class="ver" :fill="main.THIRD_COLOR"
                                        scale="2"></v-icon></RouterLink>
                            </td>                    
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </DefaultLayout>
</template>

<script  lang="ts" setup>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import ExercisesService from '@/services/ExerciseService';
import { onMounted,ref,Ref } from 'vue';
import main from '@/data/main.js';
import useWindowWidth from '@/composables/useWindowWidth';
import ActivityInterface from '@/interfaces/ActivityInterface';

const { windowWidth } = useWindowWidth()
const tableSmall = ref(850);

const loading:Ref<boolean> = ref(false)
const service = new ExercisesService()
const activities:Ref<ActivityInterface[]> = ref([])

onMounted(async()=>{
    loading.value = true
  activities.value = await service.GetExercises()
  loading.value = false
})
 


</script>

<style scoped lang="scss">

h1{
    margin-bottom: 20px;
}
h2{
    color: #aaa;
}
p{
    margin-bottom: 12px;
}
.container {
    padding: 15px;
    text-align: center;
}
a{
    text-decoration: none;
}
.modern-table {
    width: 100%;
    border-collapse: collapse;

}
a:hover{
    color: $secondary-color;
}
.modern-table th,
.modern-table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

th {
    color: $secondary-color !important;
}

.modern-table th:first-child,
.modern-table td:first-child {
    padding-left: 20px;
}

.table-container {
    overflow-x: auto;
}

.modern-table th:last-child,
.modern-table td:last-child {
    padding-right: 20px;
}

/* Estilos para el hover */
.modern-table tbody tr:hover {
    background-color: #f5f5f5;
    transition: background-color 0.3s ease;
}

.modern-table tbody tr:hover td {
    color: #333;
}

.modern-table tbody tr:hover a {
    color: $third-color;
    transition: color 0.3s ease;
}</style>